var map = {
	"./en/global-variables.json": [
		315
	],
	"./es/global-variables.json": [
		228
	],
	"./mx/global-variables.json": [
		316
	],
	"./pt/global-variables.json": [
		317
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1356;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*\/global\-variables\.json$
// module id = 1356
// module chunks = 116